import React, {useEffect} from "react";
import './ContactUs.css';

const ContactUs = () => {
  // Scroll to top on mount
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <div className="page-container">
      <h2>Contact Us</h2>
      <div className="google-form-container" style={{ marginTop: '20px' }}>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSeKWyPTzEfBCEIXfQRrk7jyIchDPf1eSfPni8LGWUnaBVoU7A/viewform?usp=sharing"
          width="100%"
          height="800"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title="Google Form"
        >
          Loading…
        </iframe>
      </div>
    </div>
  );
};

export default ContactUs;
